import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, Button } from "@mui/material";
import axios from "axios";
import LinkedInLogo from "../../assets/LinkedIn-logo.png";
import Loader from "../Loader";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

const MAX_LENGTH = 300;

const LinkedInPost = () => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showFullText, setShowFullText] = useState(false);

  useEffect(() => {
  const BACKEND_URL =
    window.location.hostname === "localhost"
      ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api"
      : process.env.REACT_APP_BACKEND_URL_PROD + "/api";

    axios
      .get(`${BACKEND_URL}/linkedin/latest-post`)
      .then((response) => {
        if (response.data && response.data.url) {
          setPost(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur chargement LinkedIn", error);
        setLoading(false);
      });
  }, []);

  const getTruncatedText = (text) => {
    if (!text) return "";
    return text.length > MAX_LENGTH && !showFullText
      ? text.substring(0, MAX_LENGTH) + "..."
      : text;
  };

  const formatDate = (dateStr) => {
    try {
      return format(new Date(dateStr), "d MMMM yyyy", { locale: fr });
    } catch {
      return "";
    }
  };

  return (
    <Card className="col-span-1 w-full" sx={{ borderRadius: 3, boxShadow: 3, overflow: "hidden" }}>
      <CardContent className="p-4" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {/* 🔹 Logo LinkedIn + date */}
        <div className="flex items-center justify-between">
          <a
            href="https://www.linkedin.com/company/nanthiat-exclusive-investment-advisory"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={LinkedInLogo}
              alt="LinkedIn"
              className="h-8 sm:h-9 md:h-10 w-auto rounded-lg"
            />
          </a>
          {!loading && post?.date && (
            <Typography variant="caption" color="text.secondary">
              {formatDate(post.date)}
            </Typography>
          )}
        </div>

        {/* 🔸 Contenu */}
        {loading ? (
          <div className="flex justify-center items-center max-h-[165px]">
            <Loader />
          </div>
        ) : post ? (
          <div className="flex flex-col gap-3">
            <Typography variant="body2" color="text.primary">
              {getTruncatedText(post.text)}
            </Typography>

            {post.text?.length > MAX_LENGTH && (
              <Button
                size="small"
                variant="text"
                onClick={() => setShowFullText((prev) => !prev)}
                sx={{ textTransform: "none", color: "primary.main", alignSelf: "flex-start" }}
              >
                {showFullText ? "Voir moins" : "Voir plus"}
              </Button>
            )}

            <a
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col sm:flex-row gap-2 items-start border rounded-md p-3 hover:bg-gray-100 transition"
            >
              {post.mediaUrl && (
                <img
                  src={post.mediaUrl}
                  alt="Aperçu média"
                  className="w-full sm:w-32 h-auto rounded-md object-cover"
                />
              )}
              <div className="flex-1 text-sm text-blue-700 underline">
                Voir le post complet sur LinkedIn
              </div>
            </a>
          </div>
        ) : (
          <Typography variant="body2" color="text.secondary">
            Aucun post disponible.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default LinkedInPost;
